import React from 'react';
import { Box, Typography } from '@mui/material';
import VideoModal from '../../../v2/MUI_custom_component/Modal/VideoModal';
const TestimonialVideoModal = ({
  open,
  onClose,
  videos = [],
  selectedVideoIndex = 0,
  videoRef,
  currentTime = 0,
  duration = 0,
  onSeek,
  onTimeUpdate,
  onVideoClick,
  videoError = false,
  modalSx = {}
}) => {
  const selectedVideo = videos[selectedVideoIndex];
  
  if (!selectedVideo) {
    return null;
  }

  const defaultModalSx = {
    p: 0,
    height: '100vh',
    ...modalSx
  };

  return (
    <VideoModal
      open={open}
      onClose={onClose}
      currentTime={currentTime}
      duration={duration}
      onSeek={onSeek}
      sx={defaultModalSx}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ 
          position: 'relative',  
          borderRadius: 2,
        }}>
          {!videoError ? (
            <Box
              ref={videoRef}
              component="video"
              src={selectedVideo.link}
              poster={selectedVideo.thumbnail}
              autoPlay
            //   muted
              preload="auto"
              playsInline
              webkit-playsinline="true"
              crossOrigin="anonymous"
              onClick={onVideoClick}
              onTimeUpdate={onTimeUpdate}
              sx={{
                width: '100%',
                height: {xs: 'auto', md:'70vh'},
                objectFit: 'cover',
                borderRadius: 2,
                cursor: 'pointer',
              }}
            />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: '80vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#000',
                  borderRadius: 2,
                  color: '#FFF',
                }}
              >
                <Typography>Video could not be loaded</Typography>
              </Box>
            )
          }
        </Box>
        
        <Box sx={{ 
          display: 'flex', 
          gap: 0.5,
          flexDirection: 'column',
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h2" sx={{ color: '#FFF' }}>
              {selectedVideo.name}
            </Typography>
            <Box sx={{ width: '1px', height: '24px', backgroundColor: '#FFF' }} />
            <Typography variant="LabelD" sx={{ color: '#FFF', textAlign: 'end' }}>
              {selectedVideo.place}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography variant="LabelD" sx={{ color: '#FFF' }}>
              {selectedVideo.role}
            </Typography>
          </Box>
        </Box>
      </Box>
    </VideoModal>
  );
};

export default TestimonialVideoModal;